module.exports = __webpack_public_path__ + "static/media/become-vip.c17ca7e1.png";